import { API, ErrorCode } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  name?: string;
};

const [useCreateKit, createKit] = createAsyncAction(
  "kits/create",
  async ({ spaceId, name }: Args) => {
    if (name?.trim().length === 0) {
      throw {
        code: ErrorCode.invalidParams,
        message: "That is not a valid name.",
      };
    }
    const res = await API.call<{ kit: string }>({
      endpoint: "kits",
      method: "POST",
      data: {
        space_id: spaceId,
        name,
      },
    });
    return { ...res, result: res.result.kit };
  }
);

export default useCreateKit;
export { createKit };
